import "./CorporateMembers.scss"
import CorporateMembersList from "../../features/CorporateMembers/CorporateMembersList";

const CorporateMembers = () => {
  
  return (
    <div>
      <CorporateMembersList />
    </div>
  );
};

export default CorporateMembers;
